import React, { useCallback, useEffect, useRef, useState, } from 'react';
import styled from 'styled-components';
import { Icon, IconLookup } from '../../Atoms/Icon';
import Menu from './Menu';
const StyledContainer = styled.div `
  display: inline-flex;
  flex-direction: column;
  position: relative;
`;
const StyledMenuContainer = styled.div `
  display: inline-flex;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
`;
const StyledIcon = styled(Icon) `
  font-size: 1.416666667rem;
  color: #676a70;
`;
// TODO: This component has some similarities to the `Select` component. I think that a good
// way to avoid repeating the code would be to abstract the menu and the options into a
// `DropdownMenu` component.
const ContextualMenu = ({ icon = IconLookup.ELLIPSIS, options, onClick = () => { }, onOptionClick = () => { }, className, menuClassName, optionClassName, portalStyle, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);
    const menuContainerRef = useRef(null);
    const portalRef = useRef(null);
    useEffect(() => {
        if (isOpen && portalRef && portalRef.current) {
            portalRef.current.focus();
        }
    }, [isOpen]);
    const closeMenu = useCallback(() => {
        setIsOpen(false);
    }, []);
    const toggleMenu = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);
    const handleOptionClick = useCallback((optionName) => {
        onOptionClick(optionName);
        closeMenu();
    }, [options, onOptionClick]);
    return (React.createElement(StyledContainer, { ref: containerRef, className: className, onClick: onClick, tabIndex: 0, onBlur: closeMenu },
        React.createElement(StyledIcon, { icon: icon, onClick: toggleMenu }),
        React.createElement(StyledMenuContainer, { ref: menuContainerRef, style: portalStyle }, isOpen && (React.createElement(Menu, { className: menuClassName, optionClassName: optionClassName, options: options, onOptionClick: handleOptionClick })))));
};
export default ContextualMenu;
